import { render, staticRenderFns } from "./PaginateNavigation.vue?vue&type=template&id=2ce04942"
import script from "./PaginateNavigation.vue?vue&type=script&lang=js"
export * from "./PaginateNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports